import { FC, ReactNode } from 'react';
import { Box, Flex, BoxProps } from '@chakra-ui/react';
import { CbBadge } from '../CbBadge';
import { Badge } from '../../types/Badge';
interface RowProps extends BoxProps {
  children: ReactNode;
}
const Row: FC<RowProps> = ({
  children,
  ...rest
}) => <Box display="flex" flexWrap="wrap" justifyContent="center" overflow="hidden" {...rest} data-sentry-element="Box" data-sentry-component="Row" data-sentry-source-file="CbBadgeGrid.tsx">
    {children}
  </Box>;
export interface CbBadgeGridProps extends Omit<BoxProps, 'onSelect'> {
  isOwnProfile: boolean;
  badges: Badge[];
  limit: number;
  selectedBadge?: Badge;
  onSelect?: (id: string) => void;
}
export const CbBadgeGrid: FC<CbBadgeGridProps> = ({
  badges = [],
  isOwnProfile,
  limit,
  onSelect,
  selectedBadge,
  ...props
}) => {
  return <Row {...props} data-sentry-element="Row" data-sentry-component="CbBadgeGrid" data-sentry-source-file="CbBadgeGrid.tsx">
      {badges?.slice(0, limit).map(badge => {
      const handleSelect = onSelect ? () => onSelect?.(badge.id) : undefined;
      return <Flex key={badge.id} minHeight={onSelect ? 20 : undefined} minWidth={onSelect ? 20 : undefined} justifyContent="center" alignItems="center">
            <CbBadge isActive={badge.active} imageUrl={badge.unlockedAt && badge.imageUrl} id={badge.id} isSelected={selectedBadge?.id === badge.id} unlockedAt={badge.unlockedAt} margin={{
          base: '10px',
          lg: '6px'
        }} onClick={handleSelect} />
          </Flex>;
    })}
    </Row>;
};